<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <geofence-conf-list [listType]="DtgListType.list"></geofence-conf-list>
    </div>
</div>